import React, {useState} from 'react';
import {useRouter} from 'next/router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {useDispatch} from 'react-redux';
import {unwrapResult} from '@reduxjs/toolkit';
import {saveProfileReview, reset} from '../../login/userSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/elements/Form.module.scss';
import useInputState from '../../hooks/forms/useInputState';
import {FormValidator, ShowValidation} from '../../utils/validation/FormValidator';
import {TextOnlyValidator} from '../../utils/validation/GeneralValidators';
import ErrorMessage from '../../elements/ErrorMessage';

const UserProfileReview = (props) => {
    const router = useRouter();
    const {fName, lName, goToReview} = props;
    const [firstName, editFirstName, resetFirstName] = useInputState(fName ? fName : '');
    const [lastName, editLastName, resetLastName] = useInputState(lName ? lName : '');
    const dispatch = useDispatch();
    const [error, editError] = useState(false);

    //load validation rules for fields
    const ValidationRules = {
        firstName: {rule: TextOnlyValidator, param: 3 },
        lastName: {rule: TextOnlyValidator, param: 3 }
    };

    //blur validation
    const validateFieldOnBlur = (e) => {
        const field = e.target;
        let value = field.value;
        const id= e.target.id;

        let res;
        if (typeof ValidationRules[id] == 'object') {
            res = ValidationRules[id].rule(value, ValidationRules[id].param);
        } else {
            res = ValidationRules[id](value);
        }
        ShowValidation(id, res);
    }

    const saveProfile = async (e) => {
        e.preventDefault();
        let validForm = FormValidator('profileForm', ValidationRules);
        
        if (validForm) {
            try {
                const resultAction  = await dispatch(saveProfileReview({firstName: firstName, lastName: lastName}));
                const response = unwrapResult(resultAction);
                if (response.status) {
                    goToReview();
                } else {
                    if (response.hasOwnProperty('error') ) {
                        if (response.error == 'login') {
                            dispatch(reset());
                        } else {
                            for (const prop in response.error) {
                                let error = response.error[prop];
                                let errorResponse  = {status: false, msg: error};
                                ShowValidation(prop, errorResponse);
                            }
                        }
                    }
                    
                }

            } catch (err) {
             
                editError('Te rugăm să încerci mai târziu');
            }
        }

    }


    return (
        <>
            <Row>
                <Col lg={8} xs={12} className="mx-auto">
                    <h1 className="heading1 py-3 font-weight-bold text-center black-text">
                      Adaugă recenzie
                    </h1>
                   
                </Col>
            </Row>
            <Row className="bg-white p-3">
                <Col lg={8} xs={12} className="mx-auto">
                    <p className="heading2 font-weight-bold mt-3 mb-0">Date personale</p>
                    <p>Avem nevoie de câteva informații despre autorul recenziei. Numele tău va apărea în dreptul postării.</p>
                    <Form className={styles.form} id="profileForm" onSubmit={saveProfile}>
                        <Form.Group as={Row} >
                            <Form.Label column sm={4}>
                            Prenume
                            </Form.Label>
                            <Col sm={4}>                
                                <Form.Control 
                                    type="text" 
                                    id="firstName"
                                    name="firstName"
                                    value={firstName}
                                    onChange={editFirstName}
                                    placeholder="Prenumele tău"
                                    onBlur={validateFieldOnBlur}
                                />
                                <Form.Text className="helper" as="div"></Form.Text> 
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} >
                            <Form.Label column sm={4}>
                            Nume
                            </Form.Label>
                            <Col sm={4}>                
                                <Form.Control 
                                    type="text" 
                                    id="lastName"
                                    name="lastName"
                                    value={lastName}
                                    onChange={editLastName}
                                    placeholder="Numele tău"
                                    onBlur={validateFieldOnBlur}
                                />
                                <Form.Text className="helper" as="div"></Form.Text> 
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="justify-content-end">
                            <Col sm="8">
                                <Button variant="primary" type="submit" >
                                    Continuă
                                    <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />
                                </Button>
                            </Col>
                        </Form.Group>

                        {error && <ErrorMessage title="Eroare" message={error} />}

                    </Form>
                </Col>
            </Row>
        </>
    );
}

export default UserProfileReview;